import { createSlice } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

export const testReferralSlice = createSlice({
    name: 'testReferral',
    initialState: {
        values: undefined,
        touched: undefined,
        showPatientDialog: false,
        showPatientHeader: false,
        openSection: 1,
    },
    reducers: {
        setTestReferralData(state, action) {
            return { ...state, ...action.payload };
        },
        setShowPatientHeader(state, action) {
            return { ...state, showPatientHeader: action.payload };
        },
        setOpenSection(state, action) {
            return { ...state, openSection: action.payload };
        },
    },
});

export const { setTestReferralData, setShowPatientHeader, setOpenSection } =
    testReferralSlice.actions;

export const useTestReferralData = () => {
    const dispatch = useDispatch();
    const testReferralData = useSelector((state) => state.testReferral);
    const showPatientHeader = useSelector((state) => state.testReferral.showPatientHeader);
    const openSection = useSelector((state) => state.testReferral.openSection);

    return {
        testReferralData,
        setTestReferralData: (state) => dispatch(setTestReferralData(state)),
        showPatientHeader,
        setShowPatientHeader: (state) => dispatch(setShowPatientHeader(state)),
        openSection,
        setOpenSection: (state) => dispatch(setOpenSection(state)),
    };
};
